import HmacSHA256 from 'crypto-js/hmac-sha256'
import encHex from 'crypto-js/enc-hex'
import { HASH_SECRET } from 'constants/secret'


export default (data) => {
    const encodedValue = JSON.stringify(data)
    const hmacSha256 = HmacSHA256(encodedValue, HASH_SECRET)

    return hmacSha256.toString(encHex)
}
